import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from 'react'
import {
  SActionBtn,
  SDrawerOrModal,
  SEditor,
  SGeneralForms,
  SListTabs,
  SLowcodeList,
  SMessage,
  STableActions,
  STitle,
} from 'shj-components'
import { config } from './config'
import { useParams } from 'react-router-dom'
import {
  ExclamationCircleOutlined,
  MinusCircleOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons'
import {
  getProductEnums,
  getCostTemplateList,
  getPriceItemDetail,
  getDeductivePricingEnum,
} from '@/services/product'
import {
  Button,
  Form,
  Input,
  Select,
  Space,
  Switch,
  Tooltip,
  message,
  Row,
  Col,
  Radio,
  InputNumber,
} from 'antd'
import { useSetState, useUpdateEffect } from 'ahooks'
import TableList from './tableList'
import TreeSelect from './treeSelect'
import { httpOrgList } from '@/services/homeService.ts'
import { useStore, useAtomValue, useAtom, useSetAtom } from 'jotai'
import styles from '../../../../index.module.less'
import { step1DataAtom, step3DataAtom, stepCommonDataAtom, stepOptionDataAtom } from '../../store'
import { cloneDeep, isArray, isEmpty } from 'lodash-es'

export default forwardRef(function TemplateIndex(props: any, ref) {
  const [priceForm] = Form.useForm()
  const listRef = useRef<any>()
  const formRef = useRef<any>()
  const [form] = Form.useForm()
  const [form1] = Form.useForm()
  const treSelect = useRef<any>()
  const { id } = useParams() // 产品id

  const [open, setOpen] = useState(false)
  const [spcialOpen, setSpcialOpen] = useState(false)
  const [budgetTypeList, setBudgetTypeList] = useState<any>([])
  const [budgetTypeId, setBudgetTypeId] = useState<any>(null)
  const [budgetTypeIdStr, setBudgetTypeIdStr] = useState<any>('')
  const [costType, setCostType] = useState<any>(null)
  const [costTypeStr, setCostTypeStr] = useState('')
  const [costTypeList, setCostTypeList] = useState<any>(null)
  const [costTemplateList, setCostTemplateList] = useState<any>([])
  const [state, setState] = useSetState<any>({
    record: {},
    selectedSpecialCodeObj: { '0': ['cjj'], '1': ['cyh06'] }, // 已选特项编码数据集
    formValues: {},
    capitalQuoteFlag: false,
    specialListObj: {},
  })
  const [tabSourceObj, setTabSourceObj] = useState<any>({})
  const [treeData, setTreeData] = useState<any>([])
  const [openShopIdsModal, setOpenShopIdsModal] = useState(false)
  const [companyList, setCompanyList] = useState<any>([])
  const [deductiveList, setDeductiveList] = useState<any>([])
  const [DecimalPrecisionList, setDecimalPrecisionList] = useState<any>([])
  const [RoundingRuleList, setRoundingRuleList] = useState<any>([])

  const [step1Data, setStep1Data] = useAtom(step1DataAtom)
  const [step3Data, setStep3Data] = useAtom(step3DataAtom)
  const [stepCommonData] = useAtom(stepCommonDataAtom)
  const [stepOptionsData] = useAtom(stepOptionDataAtom)

  const capitalQuoteFlagValue = Form.useWatch('capitalQuoteFlag', priceForm)
  const deductivePricingTypeVal = Form.useWatch('deductivePricingType', priceForm)

  useImperativeHandle(
    ref,
    () => {
      return {
        onFormSubmit: onSubmit,
      }
    },
    [step3Data]
  )

  useEffect(() => {
    if (stepCommonData.id) {
      setState({ initialValues: step3Data, capitalQuoteFlag: step3Data.capitalQuoteFlag })
      const { productCapitalSpecials } = step3Data
      const data = mergeData(productCapitalSpecials)
      initCodeObj(data)
      priceForm.setFieldsValue({ ...step3Data, productCapitalSpecials: data })
    }
  }, [step3Data, stepCommonData])

  const initCodeObj = data => {
    const obj = {}
    data?.forEach((item, index) => {
      obj[index] = item.specialCode
    })
    setState({ selectedSpecialCodeObj: obj })
  }

  const mergeData = (data = []) => {
    console.log(data)
    const grouped = data?.reduce((acc, item) => {
      const { id, key, cateName, specialCode } = item
      const realId = cateName
      if (!acc[realId]) {
        acc[realId] = { ...item, specialCode: [] }
      }
      acc[realId].specialCode.push(specialCode)
      return acc
    }, {})
    return Object.values(grouped)
  }

  useEffect(() => {
    getCostTemplateList({ enabled: true }).then((res: any) => {
      if (Array.isArray(res)) {
        const list = res.map((item: any) => ({ value: item.id, label: item.templateName }))
        setCostTemplateList(list)
      }
    })
    getCompanyList()
    getDelEnum()
    step1Data.prodType === 'PRODUCT_PACKAGE' && getEnums()
  }, [])

  useEffect(() => {
    form.setFieldValue('costTemplateId', step1Data.costTemplateId)
  }, [step1Data.costTemplateId])

  useEffect(() => {
    const searchValue = listRef.current?.getSearch()?.getFieldValue('quoteType')
    const filterList = searchValue
      ? step1Data.priceItems?.filter((price: any) => price.quoteType === searchValue)
      : step1Data.priceItems
    listRef.current?.updateDataSource([...filterList], filterList?.length)
  }, [step1Data.priceItems])

  const getDelEnum = async () => {
    const res = await getDeductivePricingEnum()
    if (Array.isArray(res)) {
      setDeductiveList(res?.map((item: any) => ({ label: item?.description, value: item?.key })))
    }
  }
  const getEnums = async () => {
    const DecimalPrecisionEnum = await getProductEnums(
      'com.shj.saas.plus.product.enums.DecimalPrecisionEnum'
    )
    const RoundingRuleEnum = await getProductEnums(
      'com.shj.saas.plus.product.enums.RoundingRuleEnum'
    )
    if (Array.isArray(DecimalPrecisionEnum)) {
      setDecimalPrecisionList(
        DecimalPrecisionEnum?.map((item: any) => ({ label: item?.description, value: item?.key }))
      )
    }
    if (Array.isArray(DecimalPrecisionEnum)) {
      setRoundingRuleList(
        RoundingRuleEnum?.map((item: any) => ({
          label: (
            <span>
              {item?.description}
              <Tooltip
                title={
                  '保留位下一位为0，则向下取，否则向上取。例如整数零舍非零入时，4.1取5，4.01取4；小数2位零舍非零入时，4.252取4.26，4.2503取4.25。'
                }
              >
                {item.key === 'ZERO_DISCARD_NON_ZERO_CARRY' ? (
                  <QuestionCircleOutlined style={{ margin: '0 2px 0 5px', color: '#999' }} />
                ) : null}
              </Tooltip>
            </span>
          ),
          value: item?.key,
        }))
      )
    }
    if (!stepCommonData.id) {
      priceForm?.setFieldsValue({
        decimalPrecision: DecimalPrecisionEnum[0]?.key,
        roundingRule: RoundingRuleEnum[0]?.key,
      }) // 默认实付款
    }
  }

  const getCompanyList = async () => {
    const res: any = await httpOrgList()
    if (Array.isArray(res)) {
      setCompanyList([{ id: '0', name: '通用' }, ...res])
    } else {
      setCompanyList([])
    }
  }

  const handleGetPriceItemDetail = async (value: any) => {
    const res = await getPriceItemDetail({
      costTemplateId: value,
      productId: id,
      packModelId: step1Data.packModelId,
    })
    if (Array.isArray(res)) {
      setStep1Data({
        ...step1Data,
        priceItems: res,
        costTemplateId: value,
      })
    } else {
      setStep1Data({
        ...step1Data,
        priceItems: [],
        costTemplateId: value,
      })
    }
  }

  const fetchList = values => {
    return new Promise((resolve, reject) => {
      try {
        let priceList = cloneDeep(step1Data.priceItems)
        if (values?.query?.quoteType) {
          priceList = priceList.filter((price: any) => price.quoteType === values?.query?.quoteType)
        }
        if (values?.query?.costType) {
          priceList = priceList.filter((price: any) => price.costType === values?.query?.costType)
        }
        resolve({ total: priceList.length, records: priceList })
        // listRef.current?.updateDataSource([...step1Data.priceItems])
      } catch (err) {
        reject({ success: false })
      }
    })
  }
  const onAdd = () => {
    setOpen(true)
    formRef.current?.onFormRef()?.setFieldsValue({ budgetTypeId: budgetTypeList[0]?.value || '' })
    setCostType(costTypeList[0].key)
    setCostTypeStr(costTypeList[0].label)
    setBudgetTypeId(budgetTypeList[0]?.value)
    setBudgetTypeIdStr(budgetTypeList[0]?.label)
  }

  const getOptions = async () => {
    return new Promise(async (resolve, reject) => {
      const tabList = await getProductEnums('com.shj.saas.plus.product.enums.CostTypeEnum')

      const budget = step1Data.specificationArgList.find(
        (item: any) => item.argCode === 'budgetType'
      )
      const budgetTypeList = budget?.values?.map((item: any) => ({
        label: item.valueName,
        value: item.valueCode,
      }))

      setBudgetTypeList(budgetTypeList)
      setCostTypeList([
        ...tabList.map(item => {
          return {
            key: item.key,
            label: item.description,
          }
        }),
      ])
      resolve({ tabList, budgetTypeList })
    })
  }
  const onCostTypeChange = (key: string) => {
    setCostType(key)
    const label = costTypeList.find((item: any) => item.key === key)?.label || ''
    setCostTypeStr(label)
  }
  // 添加特定项
  const addSpecial = record => {
    setSpcialOpen(true)
    setState({
      record,
    })
    if (record?.nodeIds?.length) {
      setTreeData([...record.nodeIds])
    } else {
      setTreeData([])
    }
  }

  // 添加适用门店
  const addShopIds = record => {
    setOpenShopIdsModal(true)
    setState({
      record,
    })
    form1.setFieldValue('shopIds', record.shopIds || [])
  }

  const handleExtendCodes = arr => {
    const result = []
    for (const str of arr) {
      for (let i = 1; i <= str.length; i++) {
        result.push(str.slice(0, i))
      }
    }
    return result
  }

  const handleOriginCodes = obj => {
    const values: any[] = Object.values(obj)
    return [...new Set(values.flat())]
  }

  const specialList = useMemo(() => {
    if (isArray(stepOptionsData.specialCodeList)) {
      const originalCodes = handleOriginCodes(state.selectedSpecialCodeObj)
      const extendCodes = handleExtendCodes(originalCodes)
      console.log(originalCodes, extendCodes, '111')
      return stepOptionsData.specialCodeList.map(item => {
        if (!isEmpty(originalCodes)) {
          item.disabled = extendCodes.includes(item.value)
          for (const code of originalCodes) {
            if (item.value.startsWith(code)) {
              item.disabled = true
            }
          }
        } else {
          item.disabled = false
        }
        return item
      })
    }
    return []
    // return stepOptionsData.specialCodeList
  }, [stepOptionsData.specialCodeList, state.selectedSpecialCodeObj])

  const extensions = {
    request: { fetchList, getOptions },
    events: {
      onAdd,
    },
    status: {},
    customRender: {
      actionRender(_, record: Record<string, any>, c) {
        return (
          <STableActions>
            {record.mathTypeStr === '特定项选材客户价合计' && (
              <SActionBtn onClick={() => addSpecial(record)}>勾选特定项</SActionBtn>
            )}
            {record.parentKind === 'ROOT' && (
              <SActionBtn onClick={() => addShopIds(record)}>适用门店</SActionBtn>
            )}
          </STableActions>
        )
      },
    },
  }
  const handleChange = e => {
    setBudgetTypeId(e)
    const label = budgetTypeList.find((item: any) => item.value === e)?.label || ''
    setBudgetTypeIdStr(label)
  }
  const chooseTreeRe = list => {
    const newList: any = list?.map((price: any) => {
      if (price.kind === state.record?.kind) {
        return {
          ...price,
          nodeIds: treeData,
        }
      }
      if (price.children?.length) {
        const newChildren = chooseTreeRe(price.children)
        return {
          ...price,
          children: newChildren,
        }
      }
      return {
        ...price,
      }
    })
    return newList
  }
  const onSubmitTreeData = () => {
    const list: any = step1Data.priceItems?.map((price: any) => {
      if (price.kind === state.record?.kind) {
        return {
          ...price,
          nodeIds: treeData,
        }
      }
      if (price.children?.length) {
        const newChildren = chooseTreeRe(price.children)
        return {
          ...price,
          children: newChildren,
        }
      }
      return {
        ...price,
      }
    })
    setStep1Data({
      ...step1Data,
      priceItems: [...list],
    })
    setSpcialOpen(false)
  }

  const chooseShopIdRe = (list, idList) => {
    const hasGeneral = idList.includes('0')
    const shops = companyList?.filter((item: any) => idList.includes(item.id))
    const newList: any = list?.map((price: any) => {
      if (price.kind === state.record?.kind) {
        return {
          ...price,
          shopIds: hasGeneral ? ['0'] : idList,
          shops: hasGeneral ? [{ id: '0', name: '通用' }] : shops,
        }
      }
      if (price.children?.length) {
        const newChildren = chooseShopIdRe(price.children, idList)
        return {
          ...price,
          children: newChildren,
        }
      }
      return {
        ...price,
      }
    })
    return newList
  }
  const onSubmitShopData = () => {
    form1.validateFields().then((val: any) => {
      const idList = val?.shopIds || []
      const shops = companyList?.filter((item: any) => idList.includes(item.id))
      const hasGeneral = idList.includes('0')
      if (hasGeneral && idList.length > 1) {
        message.error('适用门店包含通用和其它具体门店互斥')
        return
      }
      const list: any = step1Data.priceItems?.map((price: any) => {
        if (price.kind === state.record?.kind) {
          return {
            ...price,
            shopIds: hasGeneral ? ['0'] : idList,
            shops: hasGeneral ? [{ id: '0', name: '通用' }] : shops,
          }
        }
        if (price.children?.length) {
          const newChildren = chooseShopIdRe(price.children, idList)
          return {
            ...price,
            children: newChildren,
          }
        }
        return {
          ...price,
        }
      })
      setStep1Data({
        ...step1Data,
        priceItems: [...list],
      })
      setOpenShopIdsModal(false)
    })
  }

  const getSpecialCodeArr = data => {
    return data?.reduce((res, item) => {
      if (isArray(item.specialCode)) {
        const arr = item.specialCode.map(code => {
          const specialName = specialList?.filter((special: any) => special.value === code)?.[0]
            ?.label
          return {
            key: item.id || item.key,
            cateName: item.cateName,
            specialCode: code,
            specialName: specialName,
          }
        })
        res.push(...arr)
      } else {
        res.push(item)
      }
      return res
    }, [])
  }

  // 提交数据
  const onSubmit = () => {
    return new Promise((resolve, reject) => {
      priceForm
        ?.validateFields()
        .then(values => {
          console.log('submit---3', values)
          const data = {
            ...values,
            productCapitalSpecials: getSpecialCodeArr(values.productCapitalSpecials),
          }
          setStep3Data({ ...step3Data, ...data })
          resolve({ ...step3Data, ...data })
        })
        .catch(err => {
          reject(err)
        })
    }).catch(err => {
      return Promise.reject({ err })
    })
  }

  const handleListToEnabled = (list = [], enableCodes) => {
    return list.map(item => {
      if (enableCodes.includes(item.value)) {
        item.disabled = false
      }
      return item
    })
  }

  const getSelect = useCallback(
    key => {
      const oldData = state.selectedSpecialCodeObj?.[key] || []
      const newList = handleListToEnabled(cloneDeep(specialList), oldData)
      console.log(key, oldData)
      return (
        <Select
          mode={'multiple'}
          key={key}
          style={{ width: 430 }}
          showSearch
          placeholder="请选择特项代码"
          onSelect={v => {
            const selectedArr = [...oldData, v]
            setState({
              selectedSpecialCodeObj: { ...state.selectedSpecialCodeObj, [key]: selectedArr },
            })
          }}
          onDeselect={v => {
            const selectedArr = oldData.filter(key => v !== key)
            setState({
              selectedSpecialCodeObj: { ...state.selectedSpecialCodeObj, [key]: selectedArr },
            })
          }}
          filterOption={(input, option) =>
            (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())
          }
        >
          {newList.map(item => {
            return (
              <Select.Option value={item.value} key={item.value} disabled={item.disabled}>
                {item.label}
              </Select.Option>
            )
          })}
        </Select>
      )
    },
    [state.selectedSpecialCodeObj, specialList]
  )

  return (
    <div>
      <STitle title={'子集价格'} titleMode={'edit'} style={{ marginBottom: 20 }} />
      <Form
        form={priceForm}
        onValuesChange={(changedValues, allValues) => {
          setState({ formValues: { ...allValues, ...changedValues } })
        }}
        layout="vertical"
      >
         {step1Data.prodType === 'PRODUCT_PACKAGE' && (
          <>
            <Form.Item name={'decimalPrecision'} label={'显示位数'}>
              <Radio.Group options={DecimalPrecisionList} />
            </Form.Item>

            <Form.Item name={'roundingRule'} label={'取数规则'}>
              <Radio.Group options={RoundingRuleList} />
            </Form.Item>
          </>
        )}
        {step1Data.prodType === 'PRODUCT_PACKAGE' &&
        stepCommonData.chooseTimeType === 'BEFORE_SIGN' ? (
          <>
            <Row>
              <Col span={6}>
                <Form.Item
                  name={'capitalQuoteFlag'}
                  label={
                    <>
                      资金池报价{' '}
                      <Tooltip title={'是否使用资金池报价模式'}>
                        <QuestionCircleOutlined style={{ margin: '0 2px 0 5px', color: '#999' }} />
                      </Tooltip>
                    </>
                  }
                >
                  <Switch
                    checkedChildren={'是'}
                    unCheckedChildren={'否'}
                    onChange={v => {
                      setState({ capitalQuoteFlag: v })
                      console.log('change', step3Data, stepCommonData)
                      if (v) {
                        const deductivePricingTypeValue =
                          priceForm.getFieldValue('deductivePricingType')
                        if (!deductivePricingTypeValue) {
                          priceForm?.setFieldValue('deductivePricingType', 'actualPayment') // 默认实付款
                        }
                      }
                      if (
                        v &&
                        !step3Data?.productCapitalSpecials?.length &&
                        !stepCommonData.capitalQuoteFlag
                      ) {
                        setState({ selectedSpecialCodeObj: { '0': ['cjj'], '1': ['cyh06'] } })
                        priceForm.setFieldValue('productCapitalSpecials', [
                          {
                            key: '0',
                            cateName: '家具',
                            specialCode: ['cjj'],
                            specialName: '家具',
                          },
                          {
                            key: '1',
                            cateName: '灯具',
                            specialCode: ['cyh06'],
                            specialName: '灯具',
                          },
                        ])
                        priceForm.setFieldValue(
                          'capitalDesc',
                          `<p>同类界定：</p>
                        <p>家具(沙发，茶几，电视柜，餐桌，餐椅，主卧床，主卧床头柜，次卧床次卧床头柜，床垫)</p>
                      <p>灯具(餐厅灯，客厅灯，主卧灯，次卧灯)</p>
                      <p>其他(墙纸，窗帘（纱），窗帘（布），配饰)</p>
                      <p>同产品类别内部可进行替换，不同产品类别之间不可跨类替换；</p>
                      <p>标配的产品可整体或部分替换为优选库内及库外的其他同类别产品（如墙纸替换为挂画和地毯，床头柜替为梳妆台）；</p>
                      <p>替换金额多补少不退：</p>
                      <p>（列：A商品100元，替换为B商品150元。需要增配金额50元）</p>
                        <p>（列：A商品100元，替换为B商品90元。需要增配金额0元</p>`
                        )
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              {capitalQuoteFlagValue ? (
                <Col span={10}>
                  <Form.Item name={'deductivePricingType'} label={'减项计价方式'}>
                    <Radio.Group options={deductiveList} />
                  </Form.Item>
                </Col>
              ) : null}
              {capitalQuoteFlagValue && deductivePricingTypeVal === 'returnDiscount' ? (
                <Col span={8}>
                  <Form.Item name={'discountAmount'} label={'折扣数'}>
                    <InputNumber style={{ width: 120 }} min={0.01} max={1} precision={2} />
                  </Form.Item>
                </Col>
              ) : null}
            </Row>
            {state.capitalQuoteFlag ? (
              <>
                <Form.Item
                  label={
                    <>
                      资金池品类{' '}
                      <Tooltip title={'通过选择特项，划分资金池细分类别'}>
                        <QuestionCircleOutlined style={{ margin: '0 2px 0 5px', color: '#999' }} />
                      </Tooltip>
                    </>
                  }
                >
                  <Form.List name="productCapitalSpecials">
                    {(fields, { add, remove }) => (
                      <div style={{ display: 'flex', flexDirection: 'column', width: 900 }}>
                        {fields.map(field => (
                          <Space key={field.name} style={{ display: 'flex' }} align="baseline">
                            <Form.Item
                              name={[field.name, 'cateName']}
                              rules={[{ required: true, message: '不能为空' }]}
                            >
                              <Input
                                style={{ width: 430 }}
                                maxLength={15}
                                showCount
                                placeholder={'请填写品类名称'}
                                onBlur={e => {
                                  const value = e.target.value
                                  const list = priceForm.getFieldValue('productCapitalSpecials')
                                  let sameNum = 0
                                  list.forEach((item: any) => {
                                    if (item.cateName === value) {
                                      sameNum += 1
                                    }
                                  })
                                  let isRepeatName = false
                                  if (sameNum >= 2) {
                                    isRepeatName = true
                                  }
                                  if (isRepeatName) {
                                    return SMessage.confirm({
                                      title: '品类名称不能重复',
                                      content: null,
                                      onOk: () => {
                                        list[field.name].cateName = ''
                                        priceForm.setFieldValue('productCapitalSpecials', list)
                                      },
                                      onCancel: () => {
                                        list[field.name].cateName = ''
                                        priceForm.setFieldValue('productCapitalSpecials', list)
                                      },
                                    })
                                  }
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              name={[field.name, 'specialCode']}
                              rules={[{ required: true, message: '不能为空' }]}
                            >
                              {getSelect(field.name)}
                            </Form.Item>
                            <MinusCircleOutlined
                              style={{ color: '#f25a5a', marginLeft: 5 }}
                              onClick={() => {
                                console.log(field)
                                remove(field.name)
                                const newObj = { ...state.selectedSpecialCodeObj }
                                delete newObj[field.name]
                                console.log(newObj, 'del')
                                setState({ selectedSpecialCodeObj: newObj })
                              }}
                            />
                          </Space>
                        ))}
                        <Button
                          type="dashed"
                          onClick={() => {
                            add({ key: state.selectedSpecialCodeObj.length - 1 })
                          }}
                          block
                        >
                          + 添加
                        </Button>
                      </div>
                    )}
                  </Form.List>
                </Form.Item>
                <Form.Item label={'资金池说明'} name={'capitalDesc'}>
                  <SEditor />
                </Form.Item>
              </>
            ) : null}
          </>
        ) : null}
        <Form.Item
          name={'allowRefund'}
          label={
            <>
              降级是否退款{' '}
              <Tooltip title={'降级不退款则降级金额记为0元'}>
                <QuestionCircleOutlined style={{ margin: '0 2px 0 5px', color: '#999' }} />
              </Tooltip>
            </>
          }
        >
          <Switch checkedChildren={'是'} unCheckedChildren={'否'} />
        </Form.Item>
      </Form>
      <STitle title={'产品价格'} titleMode={'edit'} style={{ marginBottom: 20 }} />

      <div className={styles.infoSpan}>
        <div style={{marginBottom: -20 }}>
          <Form form={form} layout='vertical'>
            <Form.Item
              label="费用模板"
              name="costTemplateId"
              rules={[{ required: true, message: '请选择费用模板' }]}
            >
              <Select
                showSearch
                optionFilterProp="label"
                style={{ width: 300 }}
                placeholder="请选择"
                options={costTemplateList}
                onChange={handleGetPriceItemDetail}
              ></Select>
            </Form.Item>
          </Form>
        </div>
        <SLowcodeList
          ref={listRef}
          tableType="antd"
          searchMode="group"
          config={config}
          {...extensions}
          scroll={{ y: 500 }}
        />
        <SDrawerOrModal
          title="加入费用项"
          mode="drawer"
          open={open}
          onCancel={() => {
            setOpen(false)
            listRef.current?.reload()
          }}
          width={500}
          antdProps={{
            footer: null,
          }}
        >
          <SGeneralForms
            ref={formRef}
            httpOptionsFn={getOptions}
            initialValues={{}}
            layout={'vertical'}
            configs={[
              {
                formItem: [
                  {
                    label: '报价类型',
                    name: 'budgetTypeId',
                    spanCol: 24,
                    required: true,
                    children: (text: any, record: any) => {
                      return (
                        <Select
                          showSearch
                          placeholder="请选择报价类型"
                          filterOption={false}
                          style={{ width: '460px' }}
                          // onSearch={handleSearch}
                          onChange={handleChange}
                          notFoundContent={null}
                          options={budgetTypeList}
                        />
                      )
                    },
                  },
                ],
              },
            ]}
          />
          {open && (
            <>
              <SListTabs auth={true} items={costTypeList} onChange={onCostTypeChange} />
              <TableList
                costType={costType || costTypeList?.[0]?.key}
                budgetTypeId={budgetTypeId || budgetTypeList[0]?.value}
                tabSourceObj={tabSourceObj}
                packModelId={step1Data.packModelId}
                productId={id}
                budgetTypeIdStr={budgetTypeIdStr}
                costTypeStr={costTypeStr}
                setTabSourceObj={value => {
                  setTabSourceObj({ ...value })
                }}
              />
            </>
          )}
        </SDrawerOrModal>

        <SDrawerOrModal
          title="勾选特定项"
          mode="drawer"
          open={spcialOpen}
          onCancel={() => setSpcialOpen(false)}
          onOk={onSubmitTreeData}
          width={'40%'}
        >
          {spcialOpen && step1Data.treeNodes?.length > 0 && (
            <TreeSelect
              treeData={treeData}
              treeList={step1Data.treeNodes}
              ref={treSelect}
              setTreeData={v => {
                setTreeData([...v])
              }}
            />
          )}
        </SDrawerOrModal>

        <SDrawerOrModal
          title="适用门店"
          mode="modal"
          open={openShopIdsModal}
          onCancel={() => setOpenShopIdsModal(false)}
          onOk={onSubmitShopData}
          width={'40%'}
        >
          <Form form={form1}>
            <Form.Item
              label="适用门店"
              name="shopIds"
              rules={[{ required: true, message: '请选择适用门店' }]}
            >
              <Select
                mode={'multiple'}
                optionFilterProp={'name'}
                placeholder={'请选择适用门店'}
                fieldNames={{ label: 'name', value: 'id' }}
                options={[...companyList]}
              />
            </Form.Item>
          </Form>
        </SDrawerOrModal>
      </div>
    </div>
  )
})
